import { Box, FormControlLabel, Radio } from '@mui/material';
import React from 'react';

import { AbgTypography, mergeSx } from '@abg/kit-base';

import {
  formControlLabelStyles,
  radionOptionStyling,
  textBlock,
} from './print.styling';
import { PrintOptionProps } from './types';

const RadioOptionWithDescription = ({
  value,
  label,
  description,
  printOption,
  styleParts,
}: PrintOptionProps) => {
  return (
    <Box sx={radionOptionStyling}>
      <FormControlLabel
        value={value}
        control={<Radio />}
        label={label}
        sx={formControlLabelStyles(printOption, value)}
      />
      <AbgTypography
        variant="bodyRegularRegular"
        sx={mergeSx(
          textBlock,
          styleParts?.actionDialog?.childContent?.textBlock,
        )}
      >
        {description}
      </AbgTypography>
    </Box>
  );
};

export default RadioOptionWithDescription;
